import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array, Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {Location} from "../data/Location";

export class Globe extends Container {

    public readonly cityBack = array(() => this.addChild(new City()));
    public readonly globeBg = this.addChild(new Sprite());
    public readonly cityFront = array(() => this.addChild(new City()));

    private readonly _locations: Location[];

    constructor(locations: Location[]) {
        super();
        this._locations = locations;
    }

    public onLayout() {
        this.globeBg.zIndex = this.cityBack.length;
    }

    public setLocation(location: Location) {
        for (let i = 0; i < this._locations.length; i++) {
            this.cityBack[i].visible = this.cityFront[i].visible = this._locations[i] === location;
        }
    }

    public pulseLocation(delay: number, cb?: Callback) {
        const assets = this.cityBack.filter((it) => it.visible);
        for (const asset of assets) {
            asset.scaleFrom(0.9, 1, Ease.elasticOut, {delay, onComplete: cb});
        }
    }
}

class City extends Container {
    public items = array(() => this.addChild(new Sprite()));
}
